import { Model } from 'pinia-orm'

import { Attr, BelongsTo, HasMany, Num, Uid } from 'pinia-orm/dist/decorators'
import { Equipment } from 'modules/Equipment/Equipment'
import { Tenant } from 'modules/Tenant/Tenant'

export class EquipmentType extends Model {
  static override entity = 'equipment_types'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare name: string
  @Attr(null) declare description: string | null
  @Attr(null) declare is_global: boolean

  @HasMany(() => Equipment, 'equipment_id') declare equipments: Equipment[]

  @Attr(null) declare tenant_id: string
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null
}
